export { default } from "./documentWithPreviewImageContainer";
